import { render, staticRenderFns } from "./DataPlaceHolder.vue?vue&type=template&id=24bba7bc&scoped=true"
import script from "./dataplaceholder.js?vue&type=script&lang=js&external"
export * from "./dataplaceholder.js?vue&type=script&lang=js&external"
import style0 from "./dataplaceholder.scss?vue&type=style&index=0&id=24bba7bc&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bba7bc",
  null
  
)

export default component.exports